import { render, staticRenderFns } from "./deviceLabel.vue?vue&type=template&id=58512881&"
import script from "./deviceLabel.vue?vue&type=script&lang=js&"
export * from "./deviceLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports